import { useEffect } from 'react';
import {
  fetchOneLiveChatProof,
  startOneLiveChat,
} from '@belong/integrations-belong-one-chat/utils';
import { useUser } from 'src/features/users/useUser';
import { useSupportChatProvider } from '../../hooks';

export function SupportChat() {
  const provider = useSupportChatProvider();
  const { user, isLoadingUser } = useUser();
  const userId = user?.userId;

  useEffect(() => {
    if (provider !== 'one' || isLoadingUser) {
      return;
    }

    void startOneLiveChat(userId ? fetchOneLiveChatProof : undefined);
  }, [provider, userId, isLoadingUser]);

  return null;
}
